const IMMERSIVE_EXPERIENCE_MODE = ['standard', 'popup'];
export const isValidImmersiveExperienceModeSetting = (mode) => !!mode &&
    IMMERSIVE_EXPERIENCE_MODE.includes(mode);
